export default __webpack_public_path__ + "static/media/chocolate-wallpaper-3.82255a3f.jpg";